exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3Us_ajl0SCKwG8Z0zy-1Bo{margin-bottom:0px}\n", ""]);

// Exports
exports.locals = {
	"radioClass": "_3Us_ajl0SCKwG8Z0zy-1Bo"
};